import React from 'react';
import PropTypes from 'prop-types';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import { Table, Icon, Popup, Label, Divider } from 'semantic-ui-react';
import _ from 'lodash';
import { CSVLink } from 'react-csv';

import {
  commaFormatted,
} from '../../utils/helpers/formatting';

const VALUE_CELL_STYLE = { width: '50%', textAlign: 'right' };

const objToRows = obj =>
  _.map(
    _.toPairs(obj),
    ([metric, metricValue]) => {
      const value = metricValue.value || metricValue;
      if (value === undefined || (_.isObject(value) && _.isEmpty(value))) return null;
      const description = _.get(obj, `${metric}.description`);
      const formattedValue = _.isObject(value) ? <Table compact="very">{objToRows(value)}</Table> : value;
      return (
        <Table.Row key={metric}>
          <Table.Cell>
            {description && <Popup
              trigger={<span>{_.startCase(metric)} <Icon name="info circle" color="blue" /></span>}
              content={description}
            />}
            {!description && _.startCase(metric)}
          </Table.Cell>
          <Table.Cell style={VALUE_CELL_STYLE}>{commaFormatted(formattedValue)}</Table.Cell>
        </Table.Row>
      );
    },
  );

const splitByGroup = metrics => ([
  {
    title: 'Basic',
    group: _.pickBy(metrics, (value, key) => _.split(key, '_').length === 1),
  },
  {
    title: 'Page Video Views',
    group: _.pickBy(metrics, (value, key) => _.includes(key, 'page_video')),
  },
  {
    title: 'Page Engagement',
    group: _.pickBy(metrics, (value, key) => _.includes(key, 'page_consumptions') || _.includes(key, 'page_engaged')),
  },
]);

const FullMetricModal = ({
  onToggle,
  username,
  ...metrics
}) => (
  <DyzioModal
    headerText="All Facebook Page Metrics"
    size="small"
    onClose={onToggle}
    hasCloseButton
  >
    {
      _.map(splitByGroup(metrics), ({ title, group }) =>
        (
          <div key={title}>
            <h3>{title}</h3>
            <Table striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Metric</Table.HeaderCell>
                  <Table.HeaderCell style={VALUE_CELL_STYLE}>Value</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  objToRows(group)
                }
              </Table.Body>
            </Table>
            <Divider />
          </div>
        ))
    }
    <div style={{ textAlign: 'right' }}>
      <Label basic size="large" inverted color="teal">
        <Icon name="file excel outline" />
        <CSVLink
          data={_.map(_.toPairs(metrics), ([metric, { value }]) => ({ metric, value }))}
          filename={`facebook-metrics-${username}.csv`}
        >
       Download Metrics
        </CSVLink>
      </Label>
    </div>
  </DyzioModal>
);

FullMetricModal.propTypes = {
  onToggle: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
};

export default FullMetricModal;



/** WEBPACK FOOTER **
 ** ./src/components/facebook-profile-data-large/full-metric-modal.js
 **/